import {
    makeApp, device, onReady, onError, API,
} from '@skeepers/platform-framework';
import { desktopRouter, mobileRouter } from './router';
import store from './store';
import {
    API_URL, FRONT_PLAYER, EMBED_PLAYER, SENTRY_DSN, FRONT_CONNECT, MEDIAINFO_URL, IFM_CSAT_URL,
} from './config';

makeApp({
    name: 'Basic',
    api: new API('platform-basic', API_URL),
    sentryDsn: SENTRY_DSN,
    playerEmbedUrl: EMBED_PLAYER,
    playerFrontUrl: FRONT_PLAYER,
    connectFrontUrl: FRONT_CONNECT,
    ifmCsatUrl: IFM_CSAT_URL,
    mediainfoUrl: MEDIAINFO_URL,
    router: device.isDesktop ? desktopRouter : mobileRouter,
    store,
    home: '/',
    forbidden: '/forbidden',
    welcome: '/deposit',
    uploadOptions: {
        validTypes: ['IMAGE', 'VIDEO', 'AUDIO'],
        multiple: true,
    },
}).then(onReady).catch(onError);
